/* @ngInject */
export class PanelContainerController {
  /* @ngInject */
  constructor ($scope, $timeout) {
    this.$scope = $scope
    this.$timeout = $timeout
  }

  $onInit() {

    console.log('PanelContainerController : init')

    this.selectedPanel = null
      this.panels=[]
    this.onOpen = this.onOpen.bind(this)
    this.unsubscribeListener = this.$scope.$on('OPENPANEL', this.onOpen)
  }

  selectPanel(panelHash) {
    this.selectedPanel = panelHash
    this.$scope.$broadcast('t-panel-select', {
      hash: panelHash
    });
  }

  addPanel(panel) {
    // this.panels.push(panel) // BC 12/2017  panels n'avait pas été défini : je le crée en tant que tableau
    if (typeof(panel.panelid) != 'undefined') {
      this.panels[panel.panelid] = panel;
      this.panels[this.panels.length] = panel;
    }
  }

  onOpen(event, data) {
    var idPanel = data.id
    if(idPanel === undefined) return
    var leController = this;

    this.$timeout(() => {
        var panel = leController.panels[idPanel];
        if(panel === undefined) return
        panel.isOpen = true
    }, 100)

  }

}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/PanelContainer/panel-container.controller.js